
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { DraggingContext, Part, Parts } from '../types'
import { ensureTargetElement } from './helper'
import ImageShape from './shapes/ImageShape.vue'
import RectangleShape from './shapes/RectangleShape.vue'

Vue.component(ImageShape.name, ImageShape)
Vue.component(RectangleShape.name, RectangleShape)

@Component({
    name: 'shapes-chooser',
})
export default class ShapesChooser extends Vue {
    @Prop({ type: Array }) parts!: Parts
    @Prop({ type: Object }) dragging!: DraggingContext

    dX: number = 0
    dY: number = 0
    /**
     * 마우스로 끌고(Drag) 있는 HTML Element
     */
    dragElement: HTMLElement | null = null

    mousedown(part: Part, e: MouseEvent) {
        var target = ensureTargetElement(e.target as HTMLElement)
        let cs = document.defaultView?.getComputedStyle(target)
        let bounds = target.getBoundingClientRect()

        this.dX = bounds.left - e.clientX
        this.dY = bounds.top - e.clientY

        this.dragElement = target
        this.dragElement.style.width = parseFloat(cs!.width) + 'px'
        this.dragElement.style.height =
            //@ts-ignore
            this.dragElement.parentElement!.style!.height =
                parseFloat(cs!.height) + 'px'

        this.dragMove(e)

        document.documentElement.addEventListener(
            'mousemove',
            this.dragMove,
            false
        )
        document.documentElement.addEventListener(
            'mouseup',
            this.dragStop,
            false
        )
        document.documentElement.addEventListener(
            'keydown',
            this.keyDown,
            false
        )

        this.dragging.active = true
        this.dragging.cancelled = false
        this.dragging.id = part.webpartId
        this.dragging.part = part
    }

    keyDown(e: KeyboardEvent) {
        if (e.keyCode === 27) {
            this.dragging.cancelled = true
            this.dragStop()
        }
    }

    dragMove(e: MouseEvent) {
        if (this.dragElement) {
            this.dragElement.style.left = e.clientX + this.dX + 'px'
            this.dragElement.style.top = e.clientY + this.dY + 'px'
        }
    }

    dragStop() {
        document.documentElement.removeEventListener(
            'mousemove',
            this.dragMove,
            false
        )
        document.documentElement.removeEventListener(
            'mouseup',
            this.dragStop,
            false
        )
        document.documentElement.removeEventListener(
            'keydown',
            this.keyDown,
            false
        )

        if (this.dragElement) {
            //@ts-ignore
            this.dragElement.parentElement.removeAttribute('style')
            this.dragElement.removeAttribute('style')
            this.dragElement = null
        }

        this.dragging.active = false
    }
}
